<template>
  <div class="url-input">
    <div class="form-group" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 control-label'">
        {{ options.label }}
      </label>
      <span v-if="options.required" class="required">*</span>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <input class="form-control" type="text"
          :id="options.name"
          :value="value"
          @input="validate($event.target.value)"
          :name="options.name"/>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'UrlInput',
  props: {
    value: {
      type: [Array, String]
    },
    options: {
      type: Object,
      default () {
        return {
          required: false,
          name: '',
          label: '',
          fullWidth: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (!this.value) {
        return this.options.label + ' is required'
      } else if (this.invalidUrls.length) {
        let message = ''
        for (let email of this.invalidUrls) {
          message += email
          if (email !== this.invalidUrls[this.invalidUrls.length - 1]) {
            message += ', '
          }
        }
        if (this.invalidUrls.length === 1) {
          message += ' is not a valid web address'
        } else {
          message += ' are not valid web addresses'
        }
        return message
      }
    }
  },
  data () {
    return {
      isRegex: false,
      regex: /^[0-9A-z./:]+[0-9A-z]{2}$/,
      isValid: false,
      isDirty: false,
      invalidUrls: []
    }
  },
  methods: {
    validate (val = this.value) {
      if (!Array.isArray(val)) {
        val = val.split(/,\s*/)
      }
      this.$emit('input', val)
      this.isDirty = true
      if (val && val.length && val[0]) {
        this.invalidUrls = []
        for (let url of val) {
          url = url.toLowerCase()
          if (!new RegExp(this.regex).test(url)) {
            this.invalidUrls.push(url)
          }
        }
        if (this.invalidUrls.length) {
          this.isValid = this.isRegex = false
        } else {
          this.isValid = this.isRegex = true
        }
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/UrlInput.vue